import { buildQueryString, fuseBaseServiceUrl } from "./endpoints-url";

// Purpose: Encapsulates the OAuth exchange logic and provides a typed interface.

// Interfaces that specifies the OAuth exchange service. Implementations should provide
// a single function that ensures that the OAuth token is exchanged.

export interface EnsureOAuthTokenFunc {
  (mondayAppClientId: string, mondaySessionToken: string, mondayAccountSlug: string): Promise<boolean>;
}

export async function ensureOAuthToken(
  mondayAppClientId: string,
  mondaySessionToken: string,
  mondayAccountSlug: string
) {
  const tokenExists = await isOAuthTokenAvailable(mondaySessionToken);
  if (!tokenExists) {
    redirectUserToOAuthExchangePage(mondayAppClientId, mondaySessionToken, mondayAccountSlug);
  }
  return tokenExists;
}

// Ask our CLI backend if it has a permanent OAuth token stored.
export async function isOAuthTokenAvailable(sessionToken: string) {
  const fuseBaseUrl = fuseBaseServiceUrl();
  const response = await fetch(`${fuseBaseUrl}/sharedapi/utils/1.1/accesstoken?productType=monday`, {
    headers: {
      Authorization: sessionToken,
      appkey: import.meta.env.VITE_MONDAY_APP_KEY as string,
    },
  });
  return response.ok;
}

// Redirects the user to the OAuth exchange page.
function redirectUserToOAuthExchangePage(
  mondayAppClientId: string,
  mondaySessionToken: string,
  mondayAccountSlug: string
) {
  // TODO: Find a way to assert this is set; if not it's a build/env config issue
  const redirectUri = import.meta.env.VITE_OAUTH_REDIRECT_URL || "INVALID";
  const state = encodeURIComponent(
    JSON.stringify({
      token: mondaySessionToken,
      redirectUri: redirectUri,
      redirectPath: window.location.href,
    })
  );
  const queryString = buildQueryString({
    client_id: mondayAppClientId,
    redirect_uri: redirectUri,
    subdomain: mondayAccountSlug,
    state: state,
  });
  window.location.href = `https://auth.monday.com/oauth2/authorize?${queryString}`;
}
